import React, { useState } from "react";
import TextArea from "antd/es/input/TextArea";
import { AntdButton, InputField } from "../../../blueplanitUtils/InputField";
import { EMAILQUERY } from "../../../Queries/email";
import { useMutation } from "@apollo/client";
import { message } from "antd";
import { useDispatch } from "react-redux";
import { setLoader } from "../../../Slices/loaderSlice";
import CustomTable from "../../../blueplanitUtils/CustomTabels";

// Native CSV parser — replaces papaparse
const parseCSV = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const text = e.target.result;
                const lines = text.split("\n").filter((line) => line.trim() !== "");
                if (lines.length === 0) return resolve({ data: [] });
                const headers = lines[0].split(",").map((h) => h.trim().replace(/"/g, ""));
                const data = lines.slice(1).map((line) => {
                    const values = line.split(",").map((v) => v.trim().replace(/"/g, ""));
                    return headers.reduce((obj, header, i) => {
                        obj[header] = values[i] || "";
                        return obj;
                    }, {});
                });
                resolve({ data });
            } catch (err) {
                reject(err);
            }
        };
        reader.onerror = () => reject(new Error("Failed to read file"));
        reader.readAsText(file);
    });
};

function CSVEmailUploader() {
    const [csvFile, setCsvFile] = useState(null);
    const [textEmails, setTextEmails] = useState("");
    const [totalMails, setTotalMails] = useState(0);
    const [response, setResponse] = useState([]);
    const [EmailValidation] = useMutation(EMAILQUERY);
    const [Label, SetLabel] = useState("");
    const dispatch = useDispatch();

    const emailLabels = ["email", "code", "role", "free_email", "result", "reason", "send_transactional", "did_you_mean", "verifiedAt"];
    const emailColums = ["email", "code", "role", "free_email", "result", "reason", "send_transactional", "did_you_mean", "verifiedAt"];

    const handleSubmit = async () => {
        try {
            const manualEmails = textEmails
                ?.split(/[,\s\n]+/)
                ?.map((email) => email.trim())
                ?.filter(Boolean);

            if (csvFile) {
                dispatch(setLoader(true));
                try {
                    const results = await parseCSV(csvFile);
                    const columnKey = Label?.trim() || "email";
                    const csvEmails = results.data
                        ?.map((row) => row[columnKey]?.trim())
                        ?.filter(Boolean);

                    const combined = [...manualEmails, ...csvEmails];

                    if (combined.length > 0) {
                        setTotalMails(combined.length);
                        const res = await EmailValidation({
                            variables: { mails: combined },
                        });
                        setResponse(res?.data?.emailValidation);
                    } else {
                        message.info({ content: "No emails found to validate.", duration: 2 });
                        setTotalMails(0);
                    }
                } catch (parseError) {
                    console.error("CSV Parse Error:", parseError);
                    message.error({ content: "Failed to parse CSV file.", duration: 2 });
                }
                dispatch(setLoader(false));
            } else {
                if (manualEmails.length > 0) {
                    dispatch(setLoader(true));
                    setTotalMails(manualEmails.length);
                    const res = await EmailValidation({
                        variables: { mails: manualEmails },
                    });
                    setResponse(res?.data?.emailValidation);
                    dispatch(setLoader(false));
                } else {
                    setTotalMails(0);
                    message.info({ content: "No emails found to validate.", duration: 2 });
                }
            }
        } catch (err) {
            dispatch(setLoader(false));
            message.error({ content: "Debounce validate to Faild.", duration: 2 });
        }
    };

    return (
        <div className="page-wrapper">
            <div className="content container-fluid">
                <div className="row align-items-start justify-content-between">
                    <div className="col-md-10 d-flex align-items-center gap-3">
                        <input
                            type="file"
                            accept=".csv"
                            onChange={(e) => setCsvFile(e.target.files[0])}
                            className="form-control"
                            style={{ maxWidth: "200px" }}
                        />
                        <TextArea
                            rows="2"
                            className="form-control"
                            placeholder="Enter emails comma or newline separated"
                            value={textEmails}
                            onChange={(e) => setTextEmails(e.target.value)}
                            style={{ height: "40px", width: "300px", resize: "none" }}
                        />
                        <div className="col-md-2 h-10">
                            <InputField
                                style={{ height: "40px" }}
                                placeholder="provide Mail Column Label"
                                value={Label}
                                onChange={(e) => SetLabel(e.target.value)}
                            />
                        </div>
                        <AntdButton
                            onClick={handleSubmit}
                            className="btn btn-primary"
                            style={{ height: "40px", padding: "0 20px" }}
                            label="Submit"
                        />
                        <AntdButton
                            label="Clear"
                            onClick={() => {
                                setCsvFile(null);
                                setTextEmails("");
                                setTotalMails(0);
                            }}
                            className="btn btn-secondary"
                            style={{ height: "40px", padding: "0 20px" }}
                        />
                    </div>
                    <div className="col-md-2 text-center">
                        <h3 className="fw-bold">Validate Emails</h3>
                        <div className="mt-2 fs-5">Total Mails: {totalMails}</div>
                    </div>
                </div>
                <CustomTable
                    title="Email Validation Table"
                    data={response}
                    columns={emailColums}
                    dataLabel={emailLabels}
                />
            </div>
        </div>
    );
}

export default CSVEmailUploader;